import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ContractualDataModel} from '../../../../models/ContractualDataModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import { MatTableDataSource } from '@angular/material/table';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractualValuesService} from '../service-contractual-values/contractual-values.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {ProviderModel} from '../../../../models/ProviderModel';
import {ChargingMethodologyService} from '../../../general-services/service-charging-methodology/charging-methodology.service';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {PriceRangeModel} from '../../../../models/PriceRangeModel';

@Component({
  selector: 'app-edit-contractual-data',
  templateUrl: './edit-contractual-values.component.html',
  styleUrls: ['./edit-contractual-values.component.scss']
})
export class EditContractualValuesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  contractualDataEdit: ContractualDataModel;
  getPageSubscribe: Subscription;
  contractualData: ContractualDataModel;
  numAnnoMeseSelect: number;
  localCustomerSelect: LocalCustomerModel;
  contractTypeSelect: ContractTypeModel;
  resourceUnitSelect: ResourcesUnitModel;
  providerSelect: ProviderModel;
  priceRangeListSelect: Array<PriceRangeModel>;
  chargingMethodologySelect: any;
  arcSelect: number;
  bmcSelect: number;
  bmvSelect: number;
  rrcSelect: number;
  pxqSelect: number;


  allMonth: any;
  allCharging: any;
  listData: MatTableDataSource<any>;
  contractualDataJson: any;

  saveContractualData: Subscription;
  parameterSubscribe: Subscription;
  getAllChargingMethodologySubscribe: Subscription;

  registerForm: FormGroup;
  submitted = false;
  enablePriceRange: boolean;
  resetPriceRange: boolean;
  enablePXQ: boolean;
  enableArcRrc: boolean;
  enableFixed: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private contractualDataService: ContractualValuesService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService,
              private chargingMethodologyService: ChargingMethodologyService) {
    super();

    this.contractualData = new ContractualDataModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.contractTypeSelect = new ContractTypeModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.providerSelect = new ProviderModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.contractualDataJson = params['row'];
      });
    this.contractualDataEdit = JSON.parse(this.contractualDataJson) as ContractualDataModel;

    this.numAnnoMeseSelect = this.contractualDataEdit.numAnnoMese;
    this.localCustomerSelect = this.contractualDataEdit.localCustomer;
    this.resourceUnitSelect = this.contractualDataEdit.resourceUnit;
    this.contractTypeSelect = this.contractualDataEdit.contractType;
    this.chargingMethodologySelect = this.contractualDataEdit.chargingMethodology;
    this.bmcSelect = this.contractualDataEdit.bmc;
    this.bmvSelect = this.contractualDataEdit.bmv;
    this.arcSelect = this.contractualDataEdit.arc;
    this.rrcSelect =  this.contractualDataEdit.rrc;
    this.providerSelect = this.contractualDataEdit.provider;
    this.priceRangeListSelect = this.contractualDataEdit.priceRangeList;
    this.pxqSelect = this.contractualDataEdit.pxq;

    this.enablePriceRange = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.PRICE_RANGE;
    this.enablePXQ = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.PXQ;
    this.enableArcRrc = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.ARC_RRC;
    this.enableFixed = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.FIXED;

    this.registerForm = this.formBuilder.group({
      anno: [{value: '', disabled: true}, Validators.required],
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      chargingMethodology: [{value: '', disabled: false}, Validators.required],
      bmc: [{value: '', disabled: false}, Validators.required],
      bmv: [{value: '', disabled: false}, Validators.required],
      arc: [{value: '', disabled: false}, Validators.required],
      rrc: [{value: '', disabled: false}, Validators.required],
      providerCod: [{value: '', disabled: false}, Validators.required],
      pxq: [{value: '', disabled: false}, Validators.required]
    });

    this.registerForm.patchValue({
      anno: this.numAnnoMeseSelect ? this.numAnnoMeseSelect : ''
    });

    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect ? this.localCustomerSelect.cod : ''
    });

    this.registerForm.patchValue({
      contractType: this.contractTypeSelect ? this.contractTypeSelect.cod : ''
    });

    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect ? this.resourceUnitSelect.name : ''
    });

    this.registerForm.patchValue({
      providerCod: this.providerSelect ? this.providerSelect.cod : ''
    });

    this.registerForm.patchValue({
      chargingMethodology: this.chargingMethodologySelect
    });

    this.registerForm.patchValue({
      bmc: this.bmcSelect ? this.bmcSelect : 0
    });

    this.registerForm.patchValue({
      bmv: this.bmvSelect ? this.bmvSelect : 0
    });

    this.registerForm.patchValue({
      pxq: this.pxqSelect ? this.pxqSelect : 0
    });
    this.registerForm.patchValue({
      arc: this.arcSelect ? this.arcSelect : 0
    });

    this.registerForm.patchValue({
      rrc: this.rrcSelect ? this.rrcSelect : 0
    });

    this.contractualData.id = this.contractualDataEdit.id;
    this.contractualData.localCustomer = this.localCustomerSelect;
    this.contractualData.contractType = this.contractTypeSelect;
    this.contractualData.resourceUnit = this.resourceUnitSelect;
    this.contractualData.provider = this.providerSelect;
    this.contractualData.chargingMethodology = this.chargingMethodologySelect;
    this.contractualData.numAnnoMese = this.numAnnoMeseSelect;
    this.contractualData.priceRangeList = this.priceRangeListSelect;

    this.getAllMonth();
    this.getAllChargingMethodology();
  }


  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
  }

  save() {
    this.submitted = true;
    this.handleCharging(this.contractualData.chargingMethodology);
    if (this.registerForm.valid && this.checkRangeListValid()) {
      event.preventDefault();
      this.updateFieldValues();
      this.loaderService.display(true);
      this.saveContractualData = this.contractualDataService.update(this.contractualDataService.baseUrl, this.contractualData)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Contractual Value was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
            }
          },
          error => {
            toastr.error('Contractual Value was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  updateFieldValues() {
    this.contractualData.numAnnoMese = null;
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = this.registerForm.value.arc;
    this.contractualData.rrc = this.registerForm.value.rrc;
    this.contractualData.pxq = this.registerForm.value.pxq;
  }

  getAllMonth() {
    this.getPageSubscribe = this.annoMeseService.getAllMonth(this.providerSelect)
      .subscribe(
        (result: any) => {
          this.allMonth = result;
        });
  }

  getAllChargingMethodology() {
    this.getAllChargingMethodologySubscribe = this.chargingMethodologyService.getAll(this.chargingMethodologyService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.allCharging = result;
        }
      );
  }

  getElementSelectRangeList($event) {
    this.contractualData.priceRangeList = $event.priceList;
  }

  ngOnDestroy(): void {
    if (this.saveContractualData) {
      this.saveContractualData.unsubscribe();
    }
  }

  getElementSelectedLC($event) {
    this.contractualData.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedContractType($event) {
    this.contractualData.contractType = $event.row;
    this.contractTypeSelect = $event.row;
    this.registerForm.patchValue({
      contractType: this.contractTypeSelect.cod
    });
  }

  getElementSelectedResourceUnit($event) {
    this.contractualData.resourceUnit = $event.row;
    this.resourceUnitSelect = $event.row;
    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect.name
    });
  }

  getElementSelectedProvider($event: any) {
    this.contractualData.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      providerCod: this.providerSelect.cod
    });
  }

  handleMonth(element) {
    this.contractualData.numAnnoMese = element;
  }

  handleCharging(element) {
    this.contractualData.chargingMethodology = element;
    this.enablePriceRange = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PRICE_RANGE;
    this.enablePXQ = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PXQ;
    this.enableArcRrc = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.ARC_RRC;
    this.enableFixed = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.FIXED;
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = 0;
    this.contractualData.rrc = 0;

    if (this.enablePriceRange) {
      this.contractualData.bmc = 0;
      this.contractualData.bmv = 0;
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({bmc: this.contractualData.bmc});
      this.registerForm.patchValue({bmv: this.contractualData.bmv});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enablePXQ) {
      this.contractualData.pxq = this.registerForm.value.pxq;
      this.registerForm.patchValue({bmc: this.contractualData.bmc});
      this.registerForm.patchValue({bmv: this.contractualData.bmv});
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }

    if (this.enableArcRrc) {
      this.contractualData.pxq = 0;
      this.contractualData.arc = this.registerForm.value.arc;
      this.contractualData.rrc = this.registerForm.value.rrc;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enableFixed) {
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
      this.registerForm.patchValue({bmc: this.contractualData.bmc});
      this.registerForm.patchValue({bmv: this.contractualData.bmv});
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  checkRangeListValid() {
    let returnValue = false;
    if (this.enablePriceRange) {
      if (this.contractualData.priceRangeList.length > 0) {
        const lastIndexPriceRange = this.contractualData.priceRangeList.length - 1;
        if (this.contractualData.priceRangeList[lastIndexPriceRange].volMax === null) {
          returnValue = true;
        } else {
          toastr.warning('Compile last element range to continue', 'Warning');
          returnValue = false;
        }
      }
    } else {
      returnValue = true;
    }

    return returnValue;
  }
}
